import React from 'react';
import moment from 'moment-timezone';
import { BacResult } from '../interfaces/bac-result';
import { GeofenceLocation } from '../interfaces/geofence';
import { Meeting } from '../interfaces/meeting';
import { Survey } from '../interfaces/survey';
import { EVENTS_TYPES } from './constants';
import { UREvent } from '../interfaces/events';

export const getEventIcon = (
  eventType: string,
  width: number,
  height: number,
  color: string,
  chartProps?: { x: number; y: number },
  hasBackground: boolean = true,
) => {
  if (eventType === EVENTS_TYPES.MEETING) {
    return (
      <svg
        width={width}
        height={width}
        viewBox='0 0 28 27'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...chartProps}
      >
        {hasBackground && <rect width='28' height='27' rx='3' fill='white' />}
        <path
          d='M22.5 24.9998H5.5C3.57 24.9998 2 23.4298 2 21.4998V6.49982C2 4.56982 3.57 2.99982 5.5 2.99982H6.5C6.776 2.99982 7 3.22382 7 3.49982C7 3.77582 6.776 3.99982 6.5 3.99982H5.5C4.121 3.99982 3 5.12082 3 6.49982V21.4998C3 22.8788 4.121 23.9998 5.5 23.9998H22.5C23.879 23.9998 25 22.8788 25 21.4998V6.49982C25 5.12082 23.879 3.99982 22.5 3.99982H21.5C21.224 3.99982 21 3.77582 21 3.49982C21 3.22382 21.224 2.99982 21.5 2.99982H22.5C24.43 2.99982 26 4.56982 26 6.49982V21.4998C26 23.4298 24.43 24.9998 22.5 24.9998Z'
          fill={color}
        />
        <path
          d='M17.5001 3.99982H10.5001C10.2241 3.99982 10.0001 3.77582 10.0001 3.49982C10.0001 3.22382 10.2241 2.99982 10.5001 2.99982H17.5001C17.7761 2.99982 18.0001 3.22382 18.0001 3.49982C18.0001 3.77582 17.7761 3.99982 17.5001 3.99982Z'
          fill={color}
        />
        <path
          d='M25.5 9H2.5C2.224 9 2 8.776 2 8.5C2 8.224 2.224 8 2.5 8H25.5C25.776 8 26 8.224 26 8.5C26 8.776 25.776 9 25.5 9Z'
          fill={color}
        />
        <path
          d='M8.49994 5.99994C8.22394 5.99994 7.99994 5.77594 7.99994 5.49994V1.49994C7.99994 1.22394 8.22394 0.999939 8.49994 0.999939C8.77594 0.999939 8.99994 1.22394 8.99994 1.49994V5.49994C8.99994 5.77594 8.77594 5.99994 8.49994 5.99994Z'
          fill={color}
        />
        <path
          d='M19.5001 5.99994C19.2241 5.99994 19.0001 5.77594 19.0001 5.49994V1.49994C19.0001 1.22394 19.2241 0.999939 19.5001 0.999939C19.7761 0.999939 20.0001 1.22394 20.0001 1.49994V5.49994C20.0001 5.77594 19.7761 5.99994 19.5001 5.99994Z'
          fill={color}
        />
        <path
          d='M10.4999 20.9998C9.12094 20.9998 7.99994 19.8788 7.99994 18.4998C7.99994 18.2238 8.22394 17.9998 8.49994 17.9998C8.77594 17.9998 8.99994 18.2238 8.99994 18.4998C8.99994 19.3268 9.67294 19.9998 10.4999 19.9998C11.3269 19.9998 11.9999 19.3268 11.9999 18.4998C11.9999 17.6728 11.3269 16.9998 10.4999 16.9998H9.49994C9.22394 16.9998 8.99994 16.7758 8.99994 16.4998C8.99994 16.2238 9.22394 15.9998 9.49994 15.9998H10.4999C11.3269 15.9998 11.9999 15.3268 11.9999 14.4998C11.9999 13.6728 11.3269 12.9998 10.4999 12.9998C9.67294 12.9998 8.99994 13.6728 8.99994 14.4998C8.99994 14.7758 8.77594 14.9998 8.49994 14.9998C8.22394 14.9998 7.99994 14.7758 7.99994 14.4998C7.99994 13.1208 9.12094 11.9998 10.4999 11.9998C11.8789 11.9998 12.9999 13.1208 12.9999 14.4998C12.9999 15.3158 12.6059 16.0438 11.9979 16.4998C12.6059 16.9558 12.9999 17.6838 12.9999 18.4998C12.9999 19.8788 11.8789 20.9998 10.4999 20.9998Z'
          fill={color}
        />
        <path
          d='M17.4999 21C17.2239 21 16.9999 20.776 16.9999 20.5V13.707L15.8539 14.853C15.6589 15.048 15.3419 15.048 15.1469 14.853C14.9519 14.658 14.9519 14.341 15.1469 14.146L17.1469 12.146C17.2909 12.002 17.5059 11.961 17.6919 12.038C17.8779 12.115 17.9999 12.298 17.9999 12.5V20.5C17.9999 20.776 17.7759 21 17.4999 21Z'
          fill={color}
        />
        <path
          d='M19.5 21H15.5C15.224 21 15 20.776 15 20.5C15 20.224 15.224 20 15.5 20H19.5C19.776 20 20 20.224 20 20.5C20 20.776 19.776 21 19.5 21Z'
          fill={color}
        />
      </svg>
    );
  }
  if (eventType === EVENTS_TYPES.BAC) {
    return (
      <svg
        width={width}
        height={height}
        viewBox='0 0 24 27'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...chartProps}
      >
        {hasBackground && <rect width='24' height='27' rx='5' fill='white' />}
        <rect x='6.21848' y='5.35325' width='11.6095' height='19.2462' rx='1.6' stroke={color} strokeWidth='0.8' />
        <rect x='9.08188' y='9.17368' width='5.88206' height='3.9729' rx='0.6' stroke={color} strokeWidth='0.8' />
        <path
          d='M18.1505 7.08378H21.3601C22.0453 7.08378 22.6007 7.63925 22.6007 8.32446C22.6007 9.00967 22.0453 9.56515 21.3601 9.56515H18.1505V7.08378Z'
          stroke={color}
          strokeWidth='0.8'
        />
        <line
          x1='10.0351'
          y1='16.0106'
          x2='14.008'
          y2='16.0106'
          stroke={color}
          strokeWidth='0.8'
          strokeLinecap='round'
        />
        <line x1='10.0351' y1='18.874' x2='14.008' y2='18.874' stroke={color} strokeWidth='0.8' strokeLinecap='round' />
        <path
          d='M2 5.90816C2 3.79936 3.70952 2.08984 5.81832 2.08984'
          stroke={color}
          strokeWidth='0.8'
          strokeLinecap='round'
        />
        <path
          d='M3.90826 5.90922C3.90826 4.85482 4.76302 4.00006 5.81742 4.00006'
          stroke={color}
          strokeWidth='0.8'
          strokeLinecap='round'
        />
      </svg>
    );
  }

  if (eventType === EVENTS_TYPES.FAIL_BAC) {
    return (
      <svg
        width={width}
        height={height}
        viewBox='0 0 24 27'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...chartProps}
      >
        {hasBackground && <rect width='24' height='27' rx='5' fill='white' />}
        <rect
          x='6.21848'
          y='5.35325'
          width='11.6095'
          height='19.2462'
          rx='1.6'
          stroke='#ED6F6A'
          fill='#ED6F6A'
          strokeWidth='0.8'
        />
        <rect x='9.08188' y='9.17368' width='5.88206' height='3.9729' rx='0.6' stroke='#FFFF' strokeWidth='0.8' />
        <path
          d='M18.1505 7.08378H21.3601C22.0453 7.08378 22.6007 7.63925 22.6007 8.32446C22.6007 9.00967 22.0453 9.56515 21.3601 9.56515H18.1505V7.08378Z'
          stroke='#ED6F6A'
          fill='#ED6F6A'
          strokeWidth='0.8'
        />
        <line
          x1='10.0351'
          y1='16.0106'
          x2='14.008'
          y2='16.0106'
          stroke='#FFFF'
          strokeWidth='0.8'
          strokeLinecap='round'
        />
        <line x1='10.0351' y1='18.874' x2='14.008' y2='18.874' stroke='#FFFF' strokeWidth='0.8' strokeLinecap='round' />
        <path
          d='M2 5.90816C2 3.79936 3.70952 2.08984 5.81832 2.08984'
          stroke='#ED6F6A'
          strokeWidth='0.8'
          strokeLinecap='round'
        />
        <path
          d='M3.90826 5.90922C3.90826 4.85482 4.76302 4.00006 5.81742 4.00006'
          stroke='#ED6F6A'
          strokeWidth='0.8'
          strokeLinecap='round'
        />
      </svg>
    );
  }
  if (eventType === EVENTS_TYPES.GEOFENCE) {
    return (
      <svg
        width={width}
        height={height}
        viewBox='0 0 20 27'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...chartProps}
      >
        {hasBackground && <rect width='20' height='27' rx='3' fill='white' />}
        <path
          d='M10 26C9.85224 26 9.71388 25.927 9.62447 25.802C9.31388 25.364 2 15.033 2 10.5C2 5.813 5.58871 2 10 2C14.4113 2 18 5.813 18 10.5C18 15.033 10.6861 25.364 10.3755 25.802C10.2861 25.927 10.1478 26 10 26ZM10 3C6.10729 3 2.94118 6.364 2.94118 10.5C2.94118 14.148 8.48941 22.463 10 24.659C11.5106 22.462 17.0588 14.146 17.0588 10.5C17.0588 6.364 13.8927 3 10 3Z'
          fill={color}
        />
        <path
          d='M10.0001 14.9996C7.66501 14.9996 5.76477 12.9806 5.76477 10.4996C5.76477 8.01863 7.66501 5.99963 10.0001 5.99963C12.3351 5.99963 14.2354 8.01863 14.2354 10.4996C14.2354 12.9806 12.3351 14.9996 10.0001 14.9996ZM10.0001 6.99963C8.18359 6.99963 6.70595 8.56963 6.70595 10.4996C6.70595 12.4296 8.18359 13.9996 10.0001 13.9996C11.8165 13.9996 13.2942 12.4296 13.2942 10.4996C13.2942 8.56963 11.8165 6.99963 10.0001 6.99963Z'
          fill={color}
        />
      </svg>
    );
  }
  if (eventType === EVENTS_TYPES.REMOTE_MEETING) {
    return (
      <svg
        width={width}
        height={height}
        viewBox='0 0 16 12'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...chartProps}
      >
        {hasBackground && <rect width='16' height='12' rx='3' fill='white' />}
        <path
          d='M7.67418 5.33464H7.67422C8.07172 5.33435 8.45324 5.18252 8.7349 4.91187C9.01662 4.64116 9.17542 4.27365 9.17571 3.88992V3.88988C9.17571 3.60368 9.08738 3.32408 8.92214 3.08644C8.75691 2.84884 8.52228 2.66394 8.24815 2.55483C7.97403 2.44573 7.6725 2.41721 7.38162 2.47281C7.09073 2.52841 6.82327 2.66569 6.61316 2.86758C6.40302 3.06949 6.25968 3.327 6.20159 3.60764C6.14349 3.88829 6.17333 4.17918 6.28723 4.44342C6.40113 4.70764 6.59386 4.93314 6.84075 5.09165C7.08761 5.25015 7.37764 5.33464 7.67418 5.33464ZM7.01424 2.94406C7.20942 2.81875 7.43909 2.75175 7.67418 2.75175C7.9894 2.75202 8.29124 2.87248 8.51355 3.0861C8.73581 3.29966 8.8604 3.5888 8.86067 3.88992C8.86066 4.11455 8.79135 4.33431 8.66123 4.52142C8.5311 4.70857 8.34591 4.85472 8.12888 4.94111C7.91183 5.0275 7.67289 5.05013 7.44234 5.00606C7.21181 4.962 7.00031 4.85329 6.8345 4.69396C6.66871 4.53465 6.55604 4.33192 6.51042 4.11153C6.4648 3.89116 6.48819 3.66271 6.57774 3.45499C6.66729 3.24725 6.81909 3.06936 7.01424 2.94406Z'
          fill={color}
          stroke={color}
          strokeWidth='0.2'
        />
        <path
          d='M5.56895 9.97991H9.77945C9.8206 9.97991 9.86044 9.96423 9.89012 9.93571C9.91987 9.90712 9.93697 9.86792 9.93697 9.8266V7.66627C9.93697 7.08844 9.69807 6.5347 9.27351 6.12674C8.84902 5.71885 8.27369 5.49004 7.6742 5.49004C7.0747 5.49004 6.49938 5.71885 6.07489 6.12674C5.65033 6.5347 5.41143 7.08844 5.41143 7.66627V9.8266C5.41143 9.86792 5.42853 9.90712 5.45827 9.93571C5.48795 9.96423 5.5278 9.97991 5.56895 9.97991ZM9.62193 7.66627V9.67328H5.72647V7.66627C5.72647 7.17108 5.93117 6.69575 6.29623 6.34496C6.66136 5.99411 7.157 5.79667 7.6742 5.79667C8.1914 5.79667 8.68703 5.99411 9.05217 6.34496C9.41723 6.69575 9.62193 7.17108 9.62193 7.66627Z'
          fill={color}
          stroke={color}
          strokeWidth='0.2'
        />
        <path
          d='M1.03951 9.49877H1.13951V9.39877V1.32184C1.13951 0.67635 1.61131 0.16543 2.16225 0.16543H13.069C13.6199 0.16543 14.0917 0.67635 14.0917 1.32184V9.39877V9.49877H14.1917H14.8333C14.8828 9.49877 14.9375 9.52451 14.9821 9.57441C15.0264 9.62397 15.0541 9.69047 15.0541 9.75774V10.4757C15.0541 11.2206 14.5107 11.8116 13.8709 11.8116H1.36029C0.720488 11.8116 0.177148 11.2206 0.177148 10.4757V9.75818C0.17776 9.69464 0.204926 9.6276 0.249497 9.57654C0.294306 9.52521 0.348515 9.49877 0.397934 9.49877H1.03951ZM13.5501 9.49877H13.6501V9.39877V1.32184C13.6501 0.972966 13.4066 0.683378 13.069 0.683378H2.16225C1.82462 0.683378 1.58108 0.972966 1.58108 1.32184V9.39877V9.49877H1.68108H13.5501ZM0.71872 10.0167H0.61872V10.1167V10.4757C0.61872 10.924 0.933803 11.2936 1.36029 11.2936H13.8709C14.2974 11.2936 14.6125 10.924 14.6125 10.4757V10.1167V10.0167H14.5125H0.71872Z'
          fill={color}
          stroke='white'
          strokeWidth='0.2'
        />
      </svg>
    );
  }
  if (eventType === EVENTS_TYPES.MEDICATION_TAKE) {
    return (
      <svg width={width}
        {...chartProps}
        height={height} viewBox="0 0 14 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.984863" width="12.1827" height="32.6248" rx="6.09136" stroke={color} />
        <path d="M0.599121 17.2974H12.5834" stroke={color} />
      </svg>
    )
  }
  return (
    // Survey
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...chartProps}
    >
      {hasBackground && <rect width='20' height='26' rx='3' fill='white' />}
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.8696 4.13636H16.9545C17.533 4.13636 18 4.60234 18 5.18401V22.9524C18 23.5308 17.5318 24 16.9548 24H3.04519C2.46676 24 2 23.534 2 22.9524V5.18401C2 4.60434 2.46515 4.13636 3.04554 4.13636H5.13043V3.43939C5.13043 2.86134 5.59524 2.39394 6.17325 2.39394H8.01147C8.08148 2.22357 8.18518 2.03042 8.33044 1.83637C8.71846 1.31803 9.27394 1 10 1C10.7261 1 11.2815 1.31803 11.6696 1.83637C11.8148 2.03042 11.9185 2.22357 11.9885 2.39394H13.8267C14.4035 2.39394 14.8696 2.86011 14.8696 3.43939V4.13636ZM5.82609 3.43939V5.53103C5.82609 5.72237 5.98194 5.87879 6.17287 5.87879H13.8271C14.0184 5.87879 14.1739 5.72299 14.1739 5.53103V3.43939C14.1739 3.24531 14.0195 3.09091 13.8267 3.09091H11.7391C11.5795 3.09091 11.4404 2.98208 11.4017 2.82695C11.3948 2.79941 11.3756 2.73955 11.342 2.65866C11.2845 2.52052 11.2086 2.38215 11.113 2.25454C10.8489 1.90167 10.4913 1.69697 10 1.69697C9.50867 1.69697 9.1511 1.90167 8.88695 2.25454C8.79142 2.38215 8.71548 2.52052 8.65802 2.65866C8.62439 2.73955 8.60519 2.79941 8.59831 2.82695C8.5596 2.98208 8.42048 3.09091 8.26087 3.09091H6.17325C5.98001 3.09091 5.82609 3.24569 5.82609 3.43939ZM5.13043 4.83333H3.04554C2.85 4.83333 2.69565 4.98861 2.69565 5.18401V22.9524C2.69565 23.1485 2.85042 23.303 3.04519 23.303H16.9548C17.1476 23.303 17.3043 23.1459 17.3043 22.9524V5.18401C17.3043 4.98789 17.1495 4.83333 16.9545 4.83333H14.8696V5.53103C14.8696 6.10789 14.4027 6.57576 13.8271 6.57576H6.17287C5.59747 6.57576 5.13043 6.10702 5.13043 5.53103V4.83333ZM14.52 18.4242C14.7121 18.4242 14.8679 18.5803 14.8679 18.7727C14.8679 18.9652 14.7121 19.1212 14.52 19.1212H10.0017C9.80961 19.1212 9.65388 18.9652 9.65388 18.7727C9.65388 18.5803 9.80961 18.4242 10.0017 18.4242H14.52ZM14.5183 10.0606C14.7104 10.0606 14.8661 10.2166 14.8661 10.4091C14.8661 10.6016 14.7104 10.7576 14.5183 10.7576H10C9.8079 10.7576 9.65217 10.6016 9.65217 10.4091C9.65217 10.2166 9.8079 10.0606 10 10.0606H14.5183ZM14.52 14.2424C14.7121 14.2424 14.8679 14.3984 14.8679 14.5909C14.8679 14.7834 14.7121 14.9394 14.52 14.9394H10.0017C9.80961 14.9394 9.65388 14.7834 9.65388 14.5909C9.65388 14.3984 9.80961 14.2424 10.0017 14.2424H14.52ZM5.72421 10.1627L6.17391 10.6132L7.31927 9.46571C7.45511 9.32962 7.67533 9.32962 7.81116 9.46571C7.947 9.6018 7.947 9.82244 7.81116 9.95853L6.41986 11.3525C6.28402 11.4886 6.0638 11.4886 5.92797 11.3525L5.23232 10.6555C5.09648 10.5194 5.09648 10.2988 5.23232 10.1627C5.36815 10.0266 5.58837 10.0266 5.72421 10.1627ZM5.72421 14.3445L6.17391 14.7951L7.31927 13.6475C7.45511 13.5114 7.67533 13.5114 7.81116 13.6475C7.947 13.7836 7.947 14.0043 7.81116 14.1404L6.41986 15.5343C6.28402 15.6704 6.0638 15.6704 5.92797 15.5343L5.23232 14.8373C5.09648 14.7012 5.09648 14.4806 5.23232 14.3445C5.36815 14.2084 5.58837 14.2084 5.72421 14.3445ZM5.72421 18.5263L6.17391 18.9769L7.31927 17.8293C7.45511 17.6933 7.67533 17.6933 7.81116 17.8293C7.947 17.9654 7.947 18.1861 7.81116 18.3222L6.41986 19.7161C6.28402 19.8522 6.0638 19.8522 5.92797 19.7161L5.23232 19.0191C5.09648 18.883 5.09648 18.6624 5.23232 18.5263C5.36815 18.3902 5.58837 18.3902 5.72421 18.5263Z'
        fill={color}
      />
    </svg>
  );
};

export const meetingsForUR = (meetings: Meeting[], timezone: string): UREvent[] =>
  meetings.map(value => ({
    variable: value.attended.toLowerCase().includes('remote') && value.allowRemote ? 'REMOTE_MEETING' : 'MEETING',
    title: value.title,
    timestamp: moment.utc(value.timestamp).tz(timezone).unix() * 1000,
    negative: value.attended.toLowerCase().includes('missed'),
  }));

export const geofenceForUR = (geofencePeriods: GeofenceLocation[], timezone: string): UREvent[] =>
  geofencePeriods.map(value => ({
    variable: 'GEOFENCE',
    title: `Inside ${value.title}`,
    timestamp: moment.utc(value.timestamp).tz(timezone).unix() * 1000,
    negative: value.type === 'NON_COMPLIANT',
  }));

export const bacTestForUR = (bac: BacResult[], timezone: string): UREvent[] =>
  bac.map(value => ({
    variable: 'BAC',
    title: value.title ?? value.status,
    timestamp: moment.utc(value.timestamp).tz(timezone).unix() * 1000,
    negative: ['MISS', 'FAIL', 'MISMATCH'].includes(value.title ?? value.status),
  }));

export const missedSurveysForUR = (surveys: Survey[], timezone: string): UREvent[] =>
  surveys.map(value => ({
    variable: 'SURVEY',
    title: value.title ?? value.practitionerTitle,
    timestamp: moment.utc(value.timestamp).tz(timezone).unix() * 1000,
    negative: ['MISSED', 'SKIPPED'].includes(value.responseStatus),
  }));

export const getAllEventsSingleList = (
  events: {
    meetings: Meeting[];
    geofencePeriods: GeofenceLocation[];
    bac: BacResult[];
    surveys: Survey[];
  },
  timezone: string,
): UREvent[] => {
  const meetings: UREvent[] = meetingsForUR(events.meetings, timezone);
  const geofence: UREvent[] = geofenceForUR(events.geofencePeriods, timezone);
  const bacTest: UREvent[] = bacTestForUR(events.bac, timezone);
  const missedSurveys: UREvent[] = missedSurveysForUR(events.surveys, timezone);

  return [...meetings, ...geofence, ...bacTest, ...missedSurveys];
};
